export const list = (dispatch, apiClient) => {
  dispatch({ type: 'CUSTOMERS_PENDING' });
  return apiClient
    .call({
      endpoint: 'customers/list'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMERS_LIST', list: res.data });
    })
    .catch(e => {
      dispatch({ type: 'CUSTOMERS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get customer list",
        snackType: 'warning'
      });
      throw e;
    });
};
export const listByGroupId = (dispatch, apiClient, CustomerGroupID) => {
  dispatch({ type: 'CUSTOMERS_PENDING' });
  return apiClient
    .call({
      endpoint: 'customers/listByGroupId',
      data: { CustomerGroupID }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({
        type: 'CUSTOMERS_LIST_BY_GROUP',
        groupId: CustomerGroupID,
        list: res.data
      });
    })
    .catch(e => {
      dispatch({ type: 'CUSTOMERS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get customer list br group",
        snackType: 'warning'
      });
      throw e;
    });
};
export const setLot = (dispatch, apiClient, CustomerID, Lot) => {
  return apiClient
    .call({
      endpoint: 'customers/setLot',
      data: { CustomerID, Lot }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get customer list br group",
        snackType: 'warning'
      });
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/customers.js